export enum QuillTheme {
  TOOLTIP = 'bubble',
  TOOLBAR = 'snow',
}

export interface IRichTextEditorDefaultStyleValues {
  fontFamily?: string;
  fontSize?: string;
  letterSpacing?: string;
  lineHeight?: string;
  color?: string;
  backgroundColor?: string;
}

export interface RichTextEditorProps {
  disabled?: boolean;
  fontFamily?: string[];
  fontSize?: Array<string | number>;
  hide: RichTextToolbarOptions[];
  hideToolbar?: boolean;
  letterSpacing?: (string | number)[];
  lineHeight?: (string | number)[];
  color?: string[];
  onChange: (inputText: string | null) => void;
  placeholder?: string;
  specialChars?: string[];
  theme?: QuillTheme | undefined | string;
  value?: string;
  backgroundImage?: string;
  useImmediateUpdate?: boolean;
  defaultStyleValues?: IRichTextEditorDefaultStyleValues;
  pasteWithStyle?: boolean;
  textColor?: string;
  fontSizeEditor?: string;
  lineHeightEditor?: string;
  enableSuperscriptToolbars?: boolean;
}

export enum RichTextToolbarOptions {
  BOLD = 'bold',
  ITALIC = 'italic',
  UNDERLINE = 'underline',
  STRIKE = 'strike',
  COLOR = 'color',
  BACKGROUND = 'background',
  CLEAN = 'clean',
  ALIGN = 'align',
  SPECIAL_CHAR_SELECT = 'specialCharSelect',
  FONT = 'font',
  SIZE = 'size',
  LETTER_SPACING = 'letterSpacing',
  LINE_HEIGHT = 'lineHeight',
  SUPER_SCRIPT = 'superscript',
}
